/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Activity_PruningInputs */

const vi_care_log_activity_pruning = /** @type {(inputs: Care_Log_Activity_PruningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đốn chè`)
};

/**

* @param {Care_Log_Activity_PruningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_activity_pruning = /** @type {((inputs?: Care_Log_Activity_PruningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Activity_PruningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_activity_pruning(inputs)
});